export type Language = 'en' | 'zh' | 'ja'

export const translations = {
  en: {
    'app.toggleTheme': 'Toggle theme',
    'app.exportImage': 'Export Image',
    'editor.title': 'Editor',
    'editor.placeholder': 'Type your Markdown here...',
    'preview.title': 'Preview',
    'export.title': 'Export Preview',
    'export.size': 'Size:',
    'export.sizeWechat': 'Long Article',
    'export.theme': 'Theme:',
    'export.themeNordic': 'Nordic White',
    'export.themeWarm': 'Warm Beige',
    'export.themeCool': 'Cool Blue',
    'export.themeDark': 'Dark',
    'export.cancel': 'Cancel',
    'export.exporting': 'Exporting...',
    'export.download': 'Download Image',
    'export.failed': 'Export failed, please try again',
    'mermaid.error': 'Mermaid rendering error:',
  },
  zh: {
    'app.toggleTheme': '切换主题',
    'app.exportImage': '导出图片',
    'editor.title': '编辑器',
    'editor.placeholder': '在这里输入 Markdown...',
    'preview.title': '预览',
    'export.title': '导出预览',
    'export.size': '尺寸:',
    'export.sizeWechat': '长图文',
    'export.theme': '主题:',
    'export.themeNordic': '北欧白',
    'export.themeWarm': '暖米色',
    'export.themeCool': '冷灰蓝',
    'export.themeDark': '暗夜',
    'export.cancel': '取消',
    'export.exporting': '导出中...',
    'export.download': '下载图片',
    'export.failed': '导出失败,请重试',
    'mermaid.error': 'Mermaid 渲染错误:',
  },
  ja: {
    'app.toggleTheme': 'テーマ切替',
    'app.exportImage': '画像をエクスポート',
    'editor.title': 'エディター',
    'editor.placeholder': 'ここにMarkdownを入力...',
    'preview.title': 'プレビュー',
    'export.title': 'エクスポートプレビュー',
    'export.size': 'サイズ:',
    'export.sizeWechat': '長文記事',
    'export.theme': 'テーマ:',
    'export.themeNordic': 'ノルディックホワイト',
    'export.themeWarm': 'ウォームベージュ',
    'export.themeCool': 'クールブルー',
    'export.themeDark': 'ダーク',
    'export.cancel': 'キャンセル',
    'export.exporting': 'エクスポート中...',
    'export.download': '画像をダウンロード',
    'export.failed': 'エクスポートに失敗しました。再試行してください',
    'mermaid.error': 'Mermaid レンダリングエラー:',
  },
}

export type TranslationKey = keyof typeof translations.en
